/**
 * PatternBackground — simplified version for TMA projects.
 *
 * Only mesh gradient layer (no Figma SVG pattern dependency).
 * Gives glass elements colorful backdrop to refract.
 */

import React from "react";

export function PatternBackground() {
  return (
    <div
      className="fixed inset-0 z-[-1] pointer-events-none bg-mesh-gradient transform-gpu"
      aria-hidden="true"
    />
  );
}
